module.exports = __webpack_public_path__ + "static/media/stofferingen-02.0639a447.jpg";